import _ from "lodash"
import { bulkPlaceholders, sqlRun } from "./ldb"
import { ok, err, Result } from "neverthrow"
import { FusionError, serializeFusionError } from '@fusion-advantage/backcompat'

// the most params we are going to try to shove
// into a single statement
// const MAX_VARS = 1000

export const bulkInsert = async (table: string, params: any[], columnCount: number, maxVars: number = 10000): Promise<Result<void, FusionError>> => {
	if (params.length < 1) {
		return ok()
	}
	const batchMaxRowCount = Math.floor(maxVars / columnCount)
	const batchMaxParamCount = columnCount * batchMaxRowCount
	const batches = _.chunk(params, batchMaxParamCount)
	for (const batch of batches) {
		const rowCount = batch.length / columnCount
		const placeholders = bulkPlaceholders(columnCount, rowCount)
		const query = `INSERT INTO ${table} VALUES ${placeholders}`
		const rRun = await sqlRun(query, batch)
		if(rRun.isErr()) {
			return err(serializeFusionError('bulkInsert', rRun.error))
		}
	}
	return ok()
}
